;(function () {
    function cartGlobals() {
        /**
         * Injects HTML in to the slideout cart
         *
         * @param { newCart } object - the cart object
         * @param { openWhenDone } boolean - whether to open the slideout cart when its populated
         */
        window._populateSlideOutCart = async function (newCart, openWhenDone) {
            let templateItemHTML =
                document.querySelector('#cart-template').innerHTML
            let sidebarContent = document.querySelector(
                '#cart-slideout-contents'
            )
            let subtotalEl = document.querySelector('#cart-slideout-subtotal')
            let outputHTML = ''

            const promises = newCart.items.map(async function (item, index) {
                let temporaryHTML = templateItemHTML

                temporaryHTML = temporaryHTML.replaceAll('#URL#', item.url)
                temporaryHTML = temporaryHTML.replaceAll(
                    '#HANDLE#',
                    item.handle
                )
                temporaryHTML = temporaryHTML.replaceAll(
                    '#TITLE#',
                    item.product_title
                )
                temporaryHTML = temporaryHTML.replaceAll(
                    '#FINALPRICE#',
                    Shopify.formatMoney(item.final_line_price)
                )
                temporaryHTML = temporaryHTML.replaceAll('#ID#', item.id)
                temporaryHTML = temporaryHTML.replaceAll('#QTY#', item.quantity)
                temporaryHTML = temporaryHTML.replaceAll('#INDEX#', index + 1)
                temporaryHTML = temporaryHTML.replaceAll('#IMG#', item.image)

                let metaData = await _ajaxGetVariantStock(item.handle)
                let variantStock = metaData.variantStock

                if (variantStock && variantStock[item.id]) {
                    temporaryHTML = temporaryHTML.replaceAll(
                        '#STOCK#',
                        variantStock[item.id].inventory
                    )
                    if (
                        variantStock[item.id].inventory_policy == 'continue' ||
                        variantStock[item.id].inventory_management == 'null'
                    ) {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#INVALID#',
                            'invalid'
                        )
                    } else {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#INVALID#',
                            ''
                        )
                    }

                    if (item.quantity < variantStock[item.id].inventory) {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#DISABLED#',
                            'disabled'
                        )
                    } else {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#DISABLED#',
                            ''
                        )
                    }
                }

                if (item.final_line_price < item.original_total_price) {
                    temporaryHTML = temporaryHTML.replaceAll(
                        '#ORIGINAL#',
                        '<s>' +
                            Shopify.formatMoney(item.original_line_price) +
                            '</s>'
                    )
                } else {
                    temporaryHTML = temporaryHTML.replaceAll('#ORIGINAL#', '')
                }

                let optionsHTML = ''

                if (item.selling_plan_allocation) {
                    temporaryHTML = temporaryHTML.replaceAll(
                        '#SUBSCRIPTION#',
                        '<p>' +
                            item.selling_plan_allocation.selling_plan.name +
                            '</p>'
                    )
                } else {
                    temporaryHTML = temporaryHTML.replaceAll(
                        '#SUBSCRIPTION#',
                        ''
                    )
                }

                if (!item.product_has_only_default_variant) {
                    item.options_with_values.forEach((variant) => {
                        optionsHTML += '<span class="variant-title">'
                        optionsHTML +=
                            '<b>' + variant.name + ':</b> ' + variant.value
                        optionsHTML += '</span>'
                    })
                }

                temporaryHTML = temporaryHTML.replace('#OPTIONS#', optionsHTML)

                if (enable_minmax_buys) {
                    let metafields = await _ajaxGetMetafields(item.handle)

                    if (
                        metafields &&
                        metafields.min_buy &&
                        metafields.max_buy
                    ) {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#MIN#',
                            metafields.min_buy
                        )
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#MAX#',
                            metafields.max_buy
                        )
                    }
                } else {
                    temporaryHTML = temporaryHTML.replaceAll('#MIN#', 1)
                    temporaryHTML = temporaryHTML.replaceAll('#MAX#', 999999)
                }

                outputHTML += temporaryHTML

                // remove upsell if this is the product being upsold
                if (
                    document.querySelector(
                        '.cart-upsell__product[data-id="' + item.id + '"]'
                    )
                ) {
                    _removeUpsellItem(item.id)
                }

                _updateFreeShippingElement(newCart)

                return temporaryHTML
            })

            // Wait for all promises to resolve
            const outputHTMLArray = await Promise.all(promises)

            // Concatenate all HTML strings in the array into a single string
            sidebarContent.innerHTML = outputHTMLArray.join('')
            subtotalEl.textContent = Shopify.formatMoney(newCart.total_price)

            if (openWhenDone) {
                document.body.classList.add('cart-open')
            }
        }

        /**
         * Update the slide out cart via ajax, just when clicking the qty buttons & deleting items
         *
         * @param { el } object
         * @param { callback } function
         */
        window._ajaxUpdateCart = function (el, callback = false) {
            let closestForm = el.closest('form')
            let formData = new FormData(closestForm)
            let queryString = new URLSearchParams(formData).toString()
            let updateURL =
                window.Shopify.routes.root + 'cart/update.js?' + queryString

            fetch(updateURL, {
                method: 'POST',
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        return Promise.reject(
                            'Error: Network response was not ok.'
                        )
                    }
                })
                .then((data) => {
                    // update slideout cart visible values
                    let slideOutTotal = document.querySelector(
                        '#cart-slideout-subtotal'
                    )

                    if (data.total_price && slideOutTotal) {
                        slideOutTotal.textContent = Shopify.formatMoney(
                            data.total_price
                        )

                        if (data.total_price < data.original_total_price) {
                            let slideOutOriginal = document.querySelector(
                                '#cart-slideout-original'
                            )

                            if (slideOutOriginal) {
                                slideOutOriginal.textContent =
                                    Shopify.formatMoney(
                                        data.original_total_price
                                    )
                            }
                        }

                        let slideOutDiscount = document.querySelector(
                            '#cart-slideout-discount'
                        )

                        if (slideOutDiscount && data.total_discount > 0) {
                            slideOutDiscount.textContent =
                                '-' + Shopify.formatMoney(data.total_discount)
                        } else if (slideOutDiscount) {
                            slideOutDiscount.textContent = ''
                        }
                    }

                    if (data.items) {
                        data.items.forEach((item, index) => {
                            let thisCartEl = closestForm.querySelector(
                                '[data-id="' + item.id + '"]'
                            )

                            if (thisCartEl) {
                                let thisSubtotalEl =
                                    thisCartEl.querySelector('[data-subtotal]')

                                if (thisSubtotalEl) {
                                    thisSubtotalEl.textContent =
                                        Shopify.formatMoney(item.line_price)
                                }
                            }
                        })
                    }

                    _updateFreeShippingElement(data)

                    if (callback !== false) {
                        callback()
                    }
                })
                .catch((error) => console.error(error))
        }

        /**
         *
         * Based on the min/max quantities, this checks if the user is allowed to add that many to their cart
         *
         */
        window._canUpdateCart = async function (formData) {
            let metafields = await _ajaxGetMetafields(formData.get('handle'))

            let cartData = await _getCart()

            let maxLimitReached = false
            let minLimitReached = false
            let amended = false
            let found = false
            let tryingToAdd = formData.get('quantity')

            cartData.items.forEach((item) => {
                // cartData/item = the cart/item state right now
                // tryingToAdd = the quantity we're trying to add
                // if the quantity we're trying to add, plus whatever is already in the cart, is more than the max, amend the qty in the cart to the max
                // if the quantity we're trying to add, plus whatever is already in the cart, is less than the min, amend the qty in the cart to the min
                if (item.id == formData.get('id')) {
                    found = true

                    if (
                        !formData.get('direction') ||
                        formData.get('direction') == 'increment'
                    ) {
                        if (
                            parseInt(tryingToAdd) + parseInt(item.quantity) >
                            metafields.max_buy
                        ) {
                            _doMaxLimit()
                        }
                    }

                    if (
                        !formData.get('direction') ||
                        formData.get('direction') == 'decrement'
                    ) {
                        if (
                            parseInt(tryingToAdd) + parseInt(item.quantity) <
                            metafields.min_buy
                        ) {
                            _doMinLimit()
                        }
                    }
                }
            })

            // must be adding a new one
            if (!found) {
                if (
                    !formData.get('direction') ||
                    formData.get('direction') == 'increment'
                ) {
                    if (parseInt(tryingToAdd) > metafields.max_buy) {
                        _doMaxLimit()
                    }
                }
                if (
                    !formData.get('direction') ||
                    formData.get('direction') == 'decrement'
                ) {
                    if (parseInt(tryingToAdd) < metafields.min_buy) {
                        _doMinLimit()
                    }
                }
            }

            /**
             *
             * Runs if they hit the minimum limit
             *
             */
            function _doMinLimit() {
                // this line updates the cart to be the minimum
                amended = metafields.min_buy

                minLimitReached = true

                // replace this alert with a modal or anything you like
                _toastAlert(`
				<p>This product has a minimum purchase quantity of ${metafields.min_buy}.</p>
				<p>Your cart has been updated.</p>
			`)
            }

            /**
             *
             * Runs if they hit the maximum limit
             *
             */
            function _doMaxLimit() {
                // this line updates the cart to be the maximum
                amended = metafields.max_buy

                maxLimitReached = true

                // replace this alert with a modal or anything you like
                _toastAlert(`
				<p>This product has a maximum quantity limit of ${metafields.max_buy}.</p>
				<p>Your cart has been updated.
			`)
            }

            return {
                maxLimit: maxLimitReached,
                minLimit: minLimitReached,
                amended: amended,
                max: metafields.max_buy,
                min: metafields.min_buy,
            }
        }

        /**
         *
         * For Ajax cart support, this retrieves the contents of the cart and updates values on the page
         * It also fires the klaviyo tracking script
         *
         */
        window._updateCartTotals = async function (product, adding = true) {
            let newCart = await _getCart()

            let cartIcons = document.querySelectorAll(
                '.cart-icon span, [data-cartcount]'
            )

            cartIcons.forEach(function (el, index) {
                el.textContent = newCart.item_count
            })

            if (window.enable_slide_cart) {
                _populateSlideOutCart(newCart, true)
            }

            if (adding && product) {
                _trackKlaviyoAddToCart(newCart, product)
            }
        }

        /**
         *
         * This adds a product to the cart via ajax
         *
         */
        window._ajaxAddToCart = function (formData, callback) {
            let queryString = new URLSearchParams(formData).toString()
            let updateURL =
                window.Shopify.routes.root + 'cart/add.js?' + queryString

            if (formData.get('updating')) {
                queryString =
                    'updates[' +
                    formData.get('id') +
                    ']=' +
                    formData.get('quantity')
                updateURL =
                    window.Shopify.routes.root + 'cart/update.js?' + queryString
            }

            fetch(updateURL, {
                method: 'POST',
            })
                .then((response) =>
                    response.ok
                        ? response.json()
                        : Promise.reject('Error: Network response was not ok.')
                )
                .then((data) => {
                    callback(data)
                })
                .catch((error) => {
                    console.log('Error: ' + error)
                    callback(false)
                })
        }

        /**
         *
         * Just gets the cart and triggers a callback
         *
         */
        window._getCart = async function () {
            let cartURL = window.Shopify.routes.root + 'cart.js?'

            try {
                const response = await fetch(cartURL)
                const data = await response.text()

                return JSON.parse(data)
            } catch (error) {
                console.error('Error fetching page:', error)
                throw error
            }
        }

        /**
         *
         * Checks the input quantities on the cart page
         *
         */
        window._checkCartPageQuantities = async function (mins, maxs) {
            let cart = await _getCart()

            if (cart.items) {
                cart.items.forEach((cartItem) => {
                    if (mins[cartItem.id]) {
                        if (cartItem.quantity < mins[cartItem.id]) {
                            _thisUpdateQty(
                                cartItem.id,
                                mins[cartItem.id],
                                cartItem.title
                            )
                        }
                    }
                })
                cart.items.forEach((cartItem) => {
                    if (maxs[cartItem.id]) {
                        if (cartItem.quantity > maxs[cartItem.id]) {
                            _thisUpdateQty(
                                cartItem.id,
                                maxs[cartItem.id],
                                cartItem.title
                            )
                        }
                    }
                })
            }

            function _thisUpdateQty(id, qty, title) {
                let thisQtyInput = document.querySelector(
                    '.section-cart [data-id="' + id + '"] [name="updates[]"]'
                )
                let thisFormUpdate = thisQtyInput
                    .closest('form')
                    .querySelector('[name="update"]')

                if (thisQtyInput) {
                    thisQtyInput.value = qty
                }

                sessionStorage.setItem(
                    'toastOnLoad',
                    '<p>Updated quantity of product:<br/> <span>' +
                        title +
                        '</span> <br/>as it exceeded the allowed limit per customer.</p>'
                )

                thisFormUpdate.click()
            }
        }

        /**
         *
         * Klaviyo abandoned cart tracking
         * https://help.klaviyo.com/hc/en-us/articles/115001396711
         *
         */
        window._trackKlaviyoAddToCart = function (cartData, product) {
            if (!product || (!product.id && !product.ProductID)) {
                return
            }

            let allCartData = {},
                itemCart = {}

            // get what we can from the product obj,  ifs not there already
            if (!product.ProductID) {
                itemCart = {
                    Brand: product.vendor,
                    Categories: product.type,
                    ImageURL: product.image,
                    Name: product.product_title,
                    Price: Shopify.formatMoney(product.price),
                    CompareAtPrice: Shopify.formatMoney(
                        product.compare_at_price
                    ),
                    ProductID: product.id,
                    URL:
                        window.location.origin +
                        '/products/' +
                        product.handle +
                        '/',
                }
            } else {
                itemCart = product
            }

            if (cartData) {
                allCartData = {
                    total_price: cartData.total_price / 100,
                    $value: cartData.total_price / 100,
                    total_discount: cartData.total_discount,
                    original_total_price: cartData.original_total_price / 100,
                    items: cartData.items,
                }
            }

            allCartData = Object.assign(allCartData, itemCart)

            _learnq.push(['track', 'Added to Cart', allCartData])
        }

        /**
         *
         * This queries a template called product.metafields.liquid
         * You need to set this template up to return whatever json you want to query
         * In this function this is used for the min/max buys to query the quantity limits with ajax
         *
         */
        window._ajaxGetMetafields = async function (productHandle) {
            let thisURL =
                window.Shopify.routes.root +
                'products/' +
                productHandle +
                '/?view=metafields'

            try {
                const response = await fetch(thisURL)
                const data = await response.json()
                return data.metafields
            } catch (error) {
                console.error('Error fetching page:', error)
                throw error
            }
        }

        /**
         *
         * This queries a template called product.metafields.liquid
         * You need to set this template up to return whatever json you want to query
         * In this function this is used to query the variant Stock ajax
         *
         */
        window._ajaxGetVariantStock = async function (productHandle) {
            let thisURL =
                window.Shopify.routes.root +
                'products/' +
                productHandle +
                '/?view=metafields'

            try {
                const response = await fetch(thisURL)
                const data = await response.json()
                return data
            } catch (error) {
                console.error('Error fetching page:', error)
                throw error
            }
        }

        /**
         *
         * Creates a FormData object from a standard js object
         *
         */
        window._createFormDataFromObject = function (obj) {
            const formData = new FormData()

            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    formData.append(key, obj[key])
                }
            }

            return formData
        }

        /**
         *
         * Updates the free shipping element values when the cart changes
         *
         */
        function _updateFreeShippingElement(cart) {
            let freeShippingContainers =
                document.querySelectorAll('.free-shipping')

            if (freeShippingContainers.length) {
                freeShippingContainers.forEach((el) => {
                    let thisThreshold = el.dataset.threshold
                    let amountLeftSpan = el.querySelector('[data-amount-left]')
                    let progressWidthSpan = el.querySelector(
                        '.free-shipping__progress span'
                    )

                    progressWidthSpan.style.width =
                        (cart.total_price / thisThreshold) * 100 + '%'

                    if (cart.total_price >= thisThreshold) {
                        el.classList.remove('remaining')
                    } else {
                        amountLeftSpan.textContent = Shopify.formatMoney(
                            thisThreshold - cart.total_price
                        )
                        el.classList.add('remaining')
                    }
                })
            }
        }
    }

    function cartSlide() {
        let cartSlideTrigger = document.querySelectorAll('[data-cartslide]')

        cartSlideTrigger.forEach((item) => {
            item.addEventListener('click', function (e) {
                e.preventDefault()
                document.body.classList.toggle('cart-open')
            })
        })

        // this is a variable set within the cart-slideout.liquid file
        if (typeof customCart !== 'undefined') {
            _populateSlideOutCart(customCart, false)
        }

        /**
         *
         * Handle the remove button in the ajax cart
         *
         */
        _removeButton()

        function _removeButton() {
            let slideOutCart = document.querySelector('.cart-slideout')
            if (!slideOutCart) {
                return
            }

            slideOutCart.addEventListener('click', function (e) {
                if (e.target.classList.contains('remove-item')) {
                    e.preventDefault()

                    let thisItem = e.target.closest('.cart-item')
                    let thisQtyInput = thisItem.querySelector('[type="number"]')
                    thisQtyInput.value = 0

                    _ajaxUpdateCart(
                        slideOutCart.querySelector('form'),
                        function (response) {
                            _updateCartTotals(response, false)
                        }
                    )

                    thisItem.remove()
                }
            })
        }

        /**
         *
         * Handle the upsells in the slideout cart
         *
         */
        _upsells()

        function _upsells() {
            let slideOutCart = document.querySelector('.cart-slideout')
            if (!slideOutCart) {
                return
            }

            slideOutCart.addEventListener('click', function (e) {
                if (e.target.dataset.upsell) {
                    e.preventDefault()

                    let upsellElement = e.target.closest('.cart-upsell')

                    let formObject = {
                        id: e.target.dataset.upsell,
                        quantity: 1,
                    }

                    let thisFormData = _createFormDataFromObject(formObject)

                    e.target.textContent = 'Adding...'

                    _ajaxAddToCart(thisFormData, function (response) {
                        if (response.id) {
                            _updateCartTotals(response)
                            _removeUpsellItem(e.target.dataset.upsell)
                        } else {
                            e.target.textContent = 'Unable To Add'
                        }
                    })
                }
            })
        }

        // refresh the slider in the upsell module, when a slide is removed
        function _removeUpsellItem(id) {
            let foundProducts = document.querySelectorAll(
                '.cart-upsell__product[data-id="' + id + '"]'
            )

            foundProducts.forEach(function (el, index) {
                el.parentNode.remove()
            })

            // remove upsells if none left
            if (!foundProducts.length) {
                let foundSliders = document.querySelectorAll('.upsell-slider')
                foundSliders.forEach(function (item, index) {
                    item.remove()
                })

                return
            }

            let allUpsellEls = document.querySelectorAll(
                '[id*="upsell-slider"]'
            )

            for (const key in window.sliders) {
                if (window.sliders.hasOwnProperty(key)) {
                    const slider = window.sliders[key]
                    slider.update()
                }
            }
        }
    }

    function addToCart() {
        let addToCartForms = document.querySelectorAll(
            'form[action="/cart/add"]:not(.disable-ajax)'
        )
        let atcProcessing = false
        let runningTimeout
        let atcPopup = document.querySelector('.atc-popup')

        if (!addToCartForms.length) {
            return
        }

        if (window.enable_ajax_cart) {
            document.addEventListener('submit', async function (e) {
                let el = e.target

                if (
                    el.getAttribute('action') == '/cart/add' &&
                    !el.classList.contains('.disable-ajax')
                ) {
                    e.preventDefault()
                } else {
                    return true
                }

                if (atcProcessing) {
                    return false
                }

                let atcBtn = el.querySelector('[type="submit"]')

                if (atcBtn) {
                    atcBtn.textContent = 'Adding...'
                }

                atcProcessing = true

                let formData = new FormData(el)

                /**
                 *
                 * If min max buy limits are active, check if this can actually be added
                 *
                 */
                if (window.enable_minmax_buys) {
                    let canUpdate = await _canUpdateCart(formData)

                    if (canUpdate.amended) {
                        formData.set('quantity', canUpdate.amended)
                        formData.set('updating', true)
                    }

                    if (canUpdate.maxLimit) {
                        atcBtn.textContent = 'Limit Reached'
                    }
                }

                _ajaxAddToCart(formData, function (response) {
                    if (response.id || response.item_count) {
                        atcBtn.textContent = 'Added To Cart'
                        atcProcessing = false

                        _updateCartTotals(response)

                        // in case this is open
                        if (document.querySelector('#quickViewModal.is-open')) {
                            MicroModal.close('quickViewModal')
                        }

                        if (!window.enable_slide_cart) {
                            _toastAlert(`
							<p>Item Added To Cart</p>
							<a class="btn" href="/cart">
								View Cart
							</a>
						`)
                        }
                    } else {
                        if (atcBtn) {
                            atcBtn.textContent =
                                'Error Adding, Please Check Your Cart'
                        }
                    }
                })
            })
        } else {
            // non ajax klaviyo tracking
            addToCartForms.forEach(function (el, index) {
                el.addEventListener('submit', function (e) {
                    e.preventDefault()
                    let isQV = el.closest('#quickViewModal')

                    if (isQV) {
                        _trackKlaviyoAddToCart(false, window.qvItem)
                    } else if (typeof item !== 'undefined') {
                        _trackKlaviyoAddToCart(false, item)
                    }

                    // 100ms timeout so klaviyo can send its event off
                    setTimeout(function () {
                        el.submit()
                    }, 100)
                })
            })
        }
    }

    cartGlobals()

    window.addEventListener('load', function () {
        cartSlide()
        addToCart()
    })
})()
